/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */

const socials = () => {
  const socialMedia = document.querySelector('.js-social-media');

  if (socialMedia && window.innerWidth >= 1366) {
    const scripts = [
      'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.2', // FB
      'https://platform.twitter.com/widgets.js', // Twitterr
    ];
    for (let i = 0; i < scripts.length; i++) {
      console.log(scripts[i]);
      let s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = scripts[i];
      s.charset = 'utf-8';
      document.head.appendChild(s);
    }
  }
};

export default socials;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/eco-chisel/src/scripts/modules/socials.js